import { Space } from "@mantine/core";
import React, { useState } from "react";
import CategoryUploader from "@/components/admin/categoryManagement/CategoryUploader";
import PageHeader from "@/components/admin/header/PageHeader";
import { useCategoryTrees } from "@/hooks/useCategoryTrees";
import { useWorkspaces } from "@/hooks/useWorkspaces";
import { CategoryTreeService } from "@/services/categoryTree/categoryTree.service";
import { showError, showSuccess } from "@/utils/notification";

const CategoryUploadPage: React.FC = () => {
  const [isUploading, setIsUploading] = useState(false);
  const { mutate: mutateCategoryTrees } = useCategoryTrees();
  const { categoryMaxLevel, currentWorkspaceId } = useWorkspaces();
  const [errorMessages, setErrorMessages] = useState<string[]>([]);

  const handleUpload = async (
    defaultMaxChildren: number[],
    maxClassifications: number[],
    file: File | null,
  ) => {
    if (file === null || !currentWorkspaceId) return;

    try {
      setIsUploading(true);
      await CategoryTreeService.upload(
        defaultMaxChildren,
        maxClassifications,
        file,
        currentWorkspaceId,
      );
      await mutateCategoryTrees();
      showSuccess("アップロードが完了しました。");
    } catch (error) {
      if (Array.isArray(error)) setErrorMessages(error);
      showError("アップロードに失敗しました。");
    } finally {
      window.scrollTo({ top: 0, behavior: "smooth" });
      setIsUploading(false);
    }
  };

  return (
    <>
      <PageHeader hasBack={false} title="カテゴリ登録" />
      <CategoryUploader
        maxLevel={categoryMaxLevel}
        handleUpload={handleUpload}
        isUploading={isUploading}
        errorMessages={errorMessages}
      />
      <Space h="100px" />
    </>
  );
};

export default CategoryUploadPage;
